<div *ngFor="let message of messages" class="container mt-4">
    <div *ngIf="message.message != ''" (click)="empty(messages.indexOf(message))" class="alert" [ngClass]="{'alert-danger': message.isError, 'alert-success': !message.isError}">
        {{message.message}}
    </div>
</div>
